import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { unescapeHtml,escapeHtml,isNull } from "../../components/common/Common";

const QuestionAdd = () => {
  const navigate = useNavigate();
  const mem_idx =  Number(localStorage.getItem("mem_idx"));
  const bh_idx = Number(localStorage.getItem("mem_branch_idx"));
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //공지사항
  const newQuestion = {board_idx:0,board_bh_idx:bh_idx,quest_idx:mem_idx,board_ch_idx:0,board_title:"",board_question:""};
  const [varQuestionInfo,setQuestionInfo] = useState({});

  const GetMemberInformation = async () => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_member_childrens`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1){
        if(datas.results.length > 0) {
          const parents = datas.results;
          let ch_idx = 0;
          if(!isNull(localStorage.getItem('childrenIndex'))) ch_idx = Number(localStorage.getItem('childrenIndex'));
          //원생 선택
          let childInfo = {};
          if(ch_idx > 0) {
            childInfo = parents.find(el=>el.ch_idx===ch_idx);
          } else {
            childInfo = parents[0];
            //첫번째 자녀(원생) 정보 --> 선택 표시
            ch_idx = parents[0].ch_idx;
            localStorage.setItem('childrenIndex',ch_idx);
          }
          newQuestion.board_ch_idx = ch_idx;
          const comData = {...childInfo,...newQuestion};
          console.log(comData);
          setQuestionInfo(comData);
        } 
      } 
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    setQuestionInfo(newQuestion);
    GetMemberInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //입력값
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    setQuestionInfo({...varQuestionInfo,[name]:escapeHtml(value)});
  }

  //등록하기
  const onUpdateQuestionInformationHandler = async () => {
    const sendData = {dataInfo:varQuestionInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_inquiry_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1){
        const newIndex = datas.newIndex;
        SendPushMessage(newIndex);
        navigate('/Parents/Question');
      } else {
        alert(datas.message);
      }
    });
  }
  
  //푸시보내기
  const SendPushMessage = async (newIndex) => {
    const pushTitle = "[마마몽떼] 학부모로부터 1:1문의가 등록되었습니다.";
    const pushMessage = varQuestionInfo.board_title;
    const pushUrl = `${process.env.REACT_APP_WEB_URL}/Branch/InquiryDetail/${newIndex}`;
    const sendData = {mode:2,oppIdx:bh_idx,pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_push_single_message`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
    });
  }

  return(
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'1:1 문의 등록'} varBackString={'/Parents/Question'}/>
      <div className="vh-content-body">
        <div className="mypage-form-wrap inq-form-wrap">
          <div className="form-group mb15">
            <label className="form-label">학부모(원아)</label>
            <div className="field-group">
              <input type="text" placeholder="이름을 입력하세요." value={`${varQuestionInfo.mem_name} (${varQuestionInfo.ch_name})`} className="form-control read-txt" readOnly/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">문의 제목</label>
            <div className="field-group">
              <input type="text" name="board_title" placeholder="문의 제목을 입력하세요." value={unescapeHtml(varQuestionInfo.board_title)} className="form-control" onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">문의 내용</label>
            <div className="field-group">
              <textarea name="board_question" className="inq-txt" style={{width:"100%",minHeight:"200px"}} value={unescapeHtml(varQuestionInfo.board_question)} onChange={e=>onChangeInputHandler(e)}></textarea>
            </div>
          </div>

          <div className="form-contoller bt-btn st02">
            <Link to={'/Parents/Question'} className="form-contoller-btn btn-no" style={{width:"48%"}}>취소</Link>
            <button className="form-contoller-btn btn-yes" onClick={e=>onUpdateQuestionInformationHandler(e)}>등록</button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default QuestionAdd;